import moment from 'moment'

const toISOStringVerify = (value = '') => {
  if (moment.isMoment(value)) return value?.toISOString()
  return value
}

export default toISOStringVerify
